import { WhatsappLogoIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Whatsapp = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <WhatsappLogoIcon size={Sizes[size]} {...rest} color={fill} />;
};

Whatsapp.displayName = 'Whatsapp';
